export default "from redactive import Client as RedactiveClient\n\nclient = RedactiveClient(credential=\"{{apiKey}}\")\n"